import React, { Component, Fragment } from 'react';
import { Card } from 'antd';
import { withTranslation } from "react-i18next";
import { PageListComponent, HeaderListComponent, ListComponent } from "../../../common/component/Index";

const pageSize = 2;
const sampleItems = [
    { id: 'item-1', itemCode: 'I101', itemName: 'Rare' },
    { id: 'item-2', itemCode: 'I102', itemName: 'Medium' },
    { id: 'item-3', itemCode: 'I103', itemName: 'Well Done' },
    { id: 'item-4', itemCode: 'I104', itemName: 'Extra Spicy' },
];

class OptionSetItems extends Component {
    render() {
        const { t, match, location } = this.props;
        const optionName = location?.state?.optionName || `Option ${match.params.id}`;
        const columns = [
            { title: "Items code", dataIndex: 'itemCode', key: 'itemCode' },
            { title: "Items name", dataIndex: 'itemName', key: 'itemName' },
        ];

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={match.path}
                        titleHeader={t('navigation.option')}
                        extraBreadcrumbs={[{ title: optionName }]}
                    />
                    <Card bordered={false}>
                        <ListComponent
                            tableKey="option-items-list"
                            classChildren="p-0"
                            classParent="m-0"
                            rowKey={(record, index) => record.id || index}
                            dataSource={sampleItems}
                            columns={columns}
                            pagination={{ total: sampleItems.length, totalPage: 1, defaultCurrent: 1, pageSize }}
                        />
                    </Card>
                </PageListComponent>
            </Fragment>
        );
    }
}

export default withTranslation()(OptionSetItems);
